import AxiosPermisos  from './../axiosPermisos'
import {
  path
} from './path'
import {
  map_query
} from "@/core/functions/map-path-query"
const API_VERSION = process.env.API_VERSION
async function postUploadFile (file = {}) {
  return await AxiosPermisos.post(`${path.upload_file}`, true, file)
}
async function postDownloadFile (file_id = "") {
  return await AxiosPermisos.post(`${path.download_file}/${file_id}`, true, null, API_VERSION ?? 'v1', 'arraybuffer')
}
async function getGetFiles (query = {}) {
  let url = path.get_files
  url = url.concat(map_query(query))
  return await AxiosPermisos.get(`${url}`, true)
}
export {
  postUploadFile,
  postDownloadFile,
  getGetFiles
}